import { render, staticRenderFns } from "./personalBackground.vue?vue&type=template&id=199699e0&scoped=true"
import script from "./personalBackground.vue?vue&type=script&lang=js"
export * from "./personalBackground.vue?vue&type=script&lang=js"
import style0 from "./personalBackground.vue?vue&type=style&index=0&id=199699e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199699e0",
  null
  
)

export default component.exports